'use client';
var classes = {"root":"m_86a44da5","root--subtle":"m_220c80f2"};

export { classes as default };
//# sourceMappingURL=CloseButton.module.css.mjs.map
